import { Box, Image, Text } from "@chakra-ui/react";

import { SectionContainer } from "../../components/section-container";
import { Testimonial } from "../../components/testimonial";

const TESTIMONIAL_DATA = [
  {
    quotes: [
      `
        Clare was the best ‘gift to myself’ I could’ve asked for.  She has been so helpful in providing
        me with the dedicated time, expertise and headspace I’ve needed to just focus on me for a change,
        which has allowed me to think clearly through my professional goals for the future.
      `,
      `
        She was kind, considerate, helpful, knowledgeable and patient throughout.  I would highly
        recommend Clare to anyone who is struggling with the way forward, be that in their personal or
        professional life, or indeed both !

      `
    ],
    sources: [
      `
        - Katie Taylor
      `,
      `
        CEO & Founder of The Latte Lounge & Author of Midlife Matters
      `
    ]
  },
  {
    quotes: [
      `
        My sessions with Clare have been incredibly helpful. She's creative, kind and collaborative.
        Working together, she helped me break professional challenges down into bite size chunks, to
        come up with strategic and actionable solutions. Her encyclopaedic knowledge of our industry,
        and the people who run it, was also really useful in helping me come up with practical next
        steps. I would recommend her to any senior leaders in TV and film.
      `
    ],
    sources: [
      `
        - Lucy Pilkington
      `,
      `
        Founder & CEO, Milk & Honey Media

      `
    ]
  },
  {
    quotes: [
      `
        If you’re wondering about coaching - just do it !  Across our sessions Clare helped me identify
        what had been holding me back from making a crucial decision in my life - which has unlocked all
        sorts of positive changes.  I’m no longer stuck and in limbo and can now look to the future with
        excitement.  Thank you Clare.
      `
    ],
    sources: [
      `
        - Katy Hall
      `,
      `  
        Mid-career change
      `
    ]
  },
  {
    quotes: [
      `
        Super helpful - Clare really helped me see things from a new perspective and figure out how
        to move forward. I left each session feeling clearer and more confident about what to do next.
        I’ve also noticed a real shift in mindset and  I feel more confident and intentional in how I
        articulate my goals.
      `
    ],
    sources: [
      `
        - Domman Yakubu
      `,
      `
        Start-up Entrepreneur
      `
    ]
  }
];

export const Testimonials = () => (
  <SectionContainer heading="testimonials" numChildren={1}>
    <Box marginY="auto">
      {TESTIMONIAL_DATA.map(({ quotes, sources }) => (
        <Testimonial quotes={quotes} sources={sources} />
      ))}
    </Box>
  </SectionContainer>
);
